import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLockIconSecondary from './svgs/LockIconSecondary.js';
import SvgLockIcon from './svgs/LockIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lockIcon = (props => useIcon(SvgLockIcon, SvgLockIconSecondary, props));

export { lockIcon as default };
